import React from 'react';
import { Typography, Box, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const CertificationList = ({ certifications, onEdit, onDelete, compact = false }) => {
    if (!certifications || certifications.length === 0) {
        return (
            <Typography color="textSecondary" className="text-center py-4">
                No certifications added yet
            </Typography>
        );
    }

    if (compact) {
        return (
            <Box>
                {certifications.map(cert => (
                    <Box 
                        key={cert.id}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{ py: 1, borderBottom: '1px solid', borderColor: 'divider' }}
                    >
                        <Box>
                            <Typography variant="body1">
                                {cert.title}
                            </Typography>
                            {cert.expiration_month && cert.expiration_year && (
                                <Typography variant="body2" color="text.secondary">
                                    Expires: {cert.expiration_month}/{cert.expiration_year}
                                </Typography>
                            )}
                        </Box>
                        {(onEdit || onDelete) && (
                            <Box>
                                {onEdit && (
                                    <IconButton 
                                        size="small" 
                                        onClick={() => onEdit(cert)}
                                        sx={{ mr: 0.5 }}
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                )}
                                {onDelete && (
                                    <IconButton 
                                        size="small" 
                                        color="error"
                                        onClick={() => onDelete(cert)}
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                )}
                            </Box>
                        )}
                    </Box>
                ))}
            </Box>
        );
    }

    return (
        <Box>
            {certifications.map(cert => (
                <Box 
                    key={cert.id}
                    className="mb-4 p-3 border rounded"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="flex-start"
                >
                    <Box>
                        <Typography variant="subtitle1" className="font-semibold">
                            {cert.title}
                        </Typography>
                        {cert.description && (
                            <Typography variant="body2" className="mt-1">
                                {cert.description}
                            </Typography>
                        )}
                        <Typography variant="body2" color="textSecondary">
                            {cert.expiration_month && cert.expiration_year ? 
                                `Expires: ${cert.expiration_month}/${cert.expiration_year}` : 
                                'No expiration date'}
                        </Typography>
                    </Box>
                    {(onEdit || onDelete) && (
                        <Box>
                            {onEdit && (
                                <IconButton 
                                    size="small" 
                                    onClick={() => onEdit(cert)}
                                    className="mr-1"
                                >
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            )}
                            {onDelete && (
                                <IconButton 
                                    size="small" 
                                    color="error"
                                    onClick={() => onDelete(cert)}
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            )}
                        </Box>
                    )}
                </Box>
            ))}
        </Box>
    );
};

export default CertificationList; 